var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m156.966 17.024 79.52 79.486c4.685 4.683 4.685 12.275 0 16.958l-13.025 13.02c-4.685 4.683-12.281 4.683-16.966 0L160 80.013V260c0 5.523-4.477 10-10 10h-20c-5.523 0-10-4.477-10-10V80.013l-46.495 46.475c-4.685 4.683-12.28 4.683-16.966 0l-13.025-13.02c-4.685-4.683-4.685-12.275 0-16.958l79.52-79.486c9.37-9.365 24.562-9.365 33.932 0"
})));
export default SvgArrowUp;